import { render } from "./RecoveryPassword.vue?vue&type=template&id=11ae8f12&scoped=true"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"

import "./RecoveryPassword.vue?vue&type=style&index=0&id=11ae8f12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ae8f12"]])

export default __exports__